import React, { useState } from "react";
import Navbar from "./Navbar";
import HeaderBar from "./HeaderBar";

const SIDEBAR_WIDTH = 250;
const HEADER_HEIGHT = 80; // keep in sync with HeaderBar height + .sidebar padding-top

// Reusable shell for every admin dashboard page: a fixed brand header on top,
// a collapsible sidebar on the left, and the page content offset to the right.
const Layout = ({ children }) => {
  const [sidebarVisible, setSidebarVisible] = useState(() => {
    const stored = localStorage.getItem("sidebarVisible");
    return stored === null ? true : stored === "true";
  });

  const handleSetVisible = (value) => {
    localStorage.setItem("sidebarVisible", value);
    setSidebarVisible(value);
  };

  return (
    <div className="admin" style={{ position: "relative", minHeight: "100vh" }}>
      <HeaderBar
        sidebarVisible={sidebarVisible}
        onToggleSidebar={() => handleSetVisible(!sidebarVisible)}
      />
      <div className="tw:mt-21">
        <Navbar visible={sidebarVisible} />
      </div>
      <div
        className={`admin-content${sidebarVisible ? "" : " sidebar-hidden"}`}
        style={{
          marginLeft: sidebarVisible ? SIDEBAR_WIDTH : 0,
          transition: "margin-left 0.3s",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;
